<template>
  <transition-group
    :class="['el-upload-list', 'el-upload-list--' + listType, { 'is-disabled': computedDisabled }]"
    tag="ul"
    name="el-list"
  >
    <li
      v-for="(file, i) in files"
      :key="file.uid"
      :class="['el-upload-list__item', 'is-' + file.status, focusing ? 'focusing' : '']"
      :style="itemStyle"
      tabindex="0"
      @keydown.delete="!computedDisabled && $emit('remove', file)"
      @focus="focusing = true"
      @blur="focusing = false"
      @click="focusing = false"
    >
      <slot :file="file">
        <rt-image-preview
          v-if="file.status !== 'uploading' && ['picture-card', 'picture'].indexOf(listType) > -1"
          ref="image"
          :src="file.url"
          :preview-src-list="[file.url]"
          class="el-upload-list__item-thumbnail"
        />
        <a
          class="el-upload-list__item-name"
          @click="handleClick(file)"
        >
          <i class="el-icon-document"></i>{{ file.name }}
        </a>
        <label
          v-if="listType !== 'picture-card'"
          class="el-upload-list__item-status-label"
        >
          <rt-icon
            v-if="file.status === 'success'"
            :class="{
              'el-icon-upload-success': true,
              'el-icon-circle-check': listType === 'text' || 'picture'
            }"
            name="rt-base-circle-check-filled"
            size="16"
          ></rt-icon>

          <rt-icon
            v-else-if="file.status === 'fail'"
            :class="{
              'el-icon-circle-check': listType === 'text' || 'picture'
            }"
            :color="SCSS_VARIABLES.COLOR_DANGER"
            name="rt-base-circle-close-filled"
            size="16"
          ></rt-icon>
        </label>
        <rt-icon
          v-if="!computedDisabled"
          class="el-icon-close"
          name="rt-base-trash-can-lined"
          size="16"
          @click="$emit('remove', file)"
        ></rt-icon>
        <i
          v-if="!computedDisabled"
          class="el-icon-close-tip"
        >{{ t('el.upload.deleteTip') }}</i>
        <!--因为close按钮只在li:focus的时候 display, li blur后就不存在了，所以键盘导航时永远无法 focus到 close按钮上-->
        <el-progress
          v-if="file.status === 'uploading'"
          :type="listType === 'picture-card' ? 'circle' : 'line'"
          :stroke-width="listType === 'picture-card' ? 6 : 2"
          :percentage="parsePercentage(file.percentage)"
        >
        </el-progress>
        <span
          v-if="listType === 'picture-card'"
          class="el-upload-list__item-actions"
        >
          <span
            v-if="handlePreview && listType === 'picture-card'"
            class="el-upload-list__item-preview"
            @click="handleImagePreview(i)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            v-if="!computedDisabled"
            class="el-upload-list__item-delete"
            @click="$emit('remove', file)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </slot>
    </li>
  </transition-group>
</template>
<script>
import Locale from 'element-ui/lib/mixins/locale';
import ElProgress from 'element-ui/lib/progress';
import RtIcon from '../icon/rtIcon.vue';

export default {
  name: 'ElUploadList',
  components: { ElProgress, RtIcon },

  mixins: [Locale],

  props: {
    files: {
      type: Array,
      default () {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    handlePreview: Function,
    listType: String,
    cardWidth: Number,
    cardHeight: Number
  },

  data () {
    return {
      focusing: false
    };
  },

  inject: {
    elForm: {
      default: ''
    }
  },

  computed: {
    computedDisabled () {
      return this.disabled || (this.elForm || {}).disabled;
    },
    itemStyle () {
      return this.listType === 'picture-card' ? { width: this.cardWidth + 'px', height: this.cardHeight + 'px' } : {};
    }
  },
  methods: {
    handleImagePreview (index) {
      this.$refs.image[index].clickHandler()
    },
    parsePercentage (val) {
      return parseInt(val, 10);
    },
    handleClick (file) {
      this.handlePreview && this.handlePreview(file);
    }
  }
};
</script>



// WEBPACK FOOTER //
// upload-list.vue?e60119b8